module.exports = __webpack_public_path__ + "static/media/searchIcon.88dc4e1b.svg";